import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface BotInfoData {
  timestamp: string;
  ipAddress: string;
  userAgent: string;
  source: string;
  referrer: string;
  ipCountry: string;
}

@Component({
  selector: 'app-bot-info-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './bot-info-dialog.component.html',
  styleUrl: './bot-info-dialog.component.css',
})
export class BotInfoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<BotInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BotInfoData,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
